module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "multiselect-wrapper",
    attrs: {
      "id": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputValue),
      expression: "inputValue"
    }],
    staticClass: "select-input",
    class: {
      active: _vm.inputFocus
    },
    attrs: {
      "type": "text",
      "name": "",
      "value": ""
    },
    domProps: {
      "value": (_vm.inputValue)
    },
    on: {
      "focus": function($event) {
        _vm.focus()
      },
      "blur": function($event) {
        _vm.blur($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "select-option",
    class: {
      inputFocus: _vm.inputFocus
    },
    on: {
      "click": function($event) {
        _vm.setOption($event)
      }
    }
  }, _vm._l((_vm.options), function(elem) {
    return _c('li', {
      key: elem.key
    }, [_vm._v(_vm._s(elem))])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d54f2580"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/multiselect.vue
// module id = 577
// module chunks = 1